import React from 'react';
import {Image} from 'react-native';

const SmallSetImage = (props) => {
  const cardSet = props.cardSet

  const cardImageDict = {
    "WHIZBANG_MINISET_PLACEHOLDER": "TOYIcon_MiniSet.png",
    "WHIZBANGS_WORKSHOP": "TOYIcon.png",
    "EVENT": "EventIcon.png",
    "DEEPHOLM": "WWIcon_MiniSet.png",
    "WILD_WEST": "WWIcon.png",
    "YOGG": "TTNIcon_MiniSet.png",    
    "TITANS": "TTNIcon.png",
    "CORE": "WolfIcon.png",
    "EXPERT1": "Set1_Icon.png",
    "VANILLA": "ClassicIcon.png",
    "HOF": "HallOfFameIcon.png",
    "NAXX": "NaxxIcon.png",
    "GVG": "GvGIcon.png",
    "BRM": "BRMIcon.png",
    "TGT": "TGTIcon.png",
    "LOE": "LOEIcon.png",
    "OG": "OGIcon.png",
    "KARA": "KaraIcon.png",
    "GANGS": "GangsIcon.png",
    "UNGORO": "UNGIcon.png",
    "ICECROWN": "ICCIcon.png",
    "LOOTAPALOOZA": "LOOTIcon.png",
    "GILNEAS": "GILIcon.png",
    "BOOMSDAY": "BOTIcon.png",
    "TROLL": "TRLIcon.png",
    "DALARAN": "DALIcon.png",
    "ULDUM": "UldumIcon.png",
    "DRAGONS": "DRGIcon.png",
    "YEAR_OF_THE_DRAGON": "DRGIcon_MiniSet.png",
    "DEMON_HUNTER_INITIATE": "DHIIcon.png",
    "BLACK_TEMPLE": "BTIcon.png",
    "SCHOLOMANCE": "SCHIcon.png",
    "DARKMOON_FAIRE": "DMFIcon.png",
    "DARKMOON_RACES": "DMFIcon_MiniSet.png",
    "THE_BARRENS": "BARIcon.png",
    "WAILING_CAVERNS": "BARIcon_MiniSet.png",
    "STORMWIND": "SWIcon.png",
    "DEADMINES": "SWIcon_MiniSet.png",
    "ALTERAC_VALLEY": "AVIcon.png",
    "ONYXIA": "AVIcon_MiniSet.png",
    "THE_SUNKEN_CITY": "SCIcon.png",          
    "THRONE_TIDES": "SCIcon_MiniSet.png",
    "REVENDRETH": "REVIcon.png",
    "MAW_AND_DISORDER": "REVIcon_MiniSet.png",   
    "PATH_OF_ARTHAS": "PoAIcon.png",                     
    "RETURN_OF_THE_LICH_KING": "RLKIcon.png",
    "RETURN_TO_NAXXRAMAS": "RLKIcon_MiniSet.png",
    "BATTLE_OF_THE_BANDS": "BotBIcon.png",
    "AUDIOPOCALYPSE": "BotBIcon_MiniSet.png",
  }


  return (
    <Image style={{width: 34, height: 34}} source={require('./assets/img/set_icons/' + cardImageDict[cardSet])}/>
  )
}

export default SmallSetImage;
